var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.545 3.231a.76.76 0 0 0-1.088 0l-5.25 5.5a.75.75 0 0 0 1.084 1.034l3.96-4.143V16.25c0 .416.334.75.75.75s.75-.334.75-.75V5.622l3.956 4.147a.75.75 0 0 0 1.085-1.035l-5.25-5.5z"
  })));
};
export default SvgArrowUp;